'use client'
import { styled } from '@repo/ui'

function Svg(props) {
  const { color, ...rest } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      {...rest}>
      <path
        d="M4 3H14V9H4V3ZM16.5 6C16.5 6.82844 17.1716 7.5 18 7.5V10.5C18 11.3284 17.3284 12 16.5 12H1.5C0.671562 12 0 11.3284 0 10.5V7.5C0.828438 7.5 1.5 6.82844 1.5 6C1.5 5.17156 0.828438 4.5 0 4.5V1.5C0 0.671562 0.671562 0 1.5 0H16.5C17.3284 0 18 0.671562 18 1.5V4.5C17.1716 4.5 16.5 5.17156 16.5 6ZM15 2.75C15 2.33578 14.6642 2 14.25 2H3.75C3.33578 2 3 2.33578 3 2.75V9.25C3 9.66422 3.33578 10 3.75 10H14.25C14.6642 10 15 9.66422 15 9.25V2.75Z"
        fill={color === 'green' ? '#238037' : '#5767DD'}
      />
    </svg>
  )
}

export const Discount = styled(Svg)
